import { useDispatch, useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import ModalReportVuln from '../../../modals/ModalReportVuln';
import styles from '../DisputeFooter.module.less';
import type { CveDataDisputeReasonsType } from '../../../../../shared/cveDisputeTypes';
import type { VulnIssue } from '../../../../../shared/issuesV2';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';

/**
 * VulnerabilityIssueDetailsFooter displays the "link" which the user
 * can click to submit a vuln dispute.
 */
const VulnerabilityIssueDetailsFooter: VoidFunctionComponent = () => {
  const dispatch = useDispatch();
  const asyncStatus = useSelector(IssuesV2Store.selectors.getAsyncStatusVulnDispute);
  const issueDetails = useSelector(IssuesV2Store.selectors.getIssueDetails) as VulnIssue;
  const { vulnDisputeModal, isAnyModalOpen } = useIssueDetailsModals();

  if (!issueDetails) {
    return null;
  }

  const onSubmit = (comment: string, reason: CveDataDisputeReasonsType) =>
    dispatch(IssuesV2Store.actions.postVulnDispute(comment, reason));

  return (
    <>
      <footer className={styles.footer}>
        Found a mistake?
        {' '}
        <button
          type="button"
          className={styles.footerButton}
          onClick={() => !isAnyModalOpen && vulnDisputeModal.onOpen()}
          disabled={isAnyModalOpen}
        >
          Report a data issue with this vulnerability.
        </button>
      </footer>
      <ModalReportVuln
        show={vulnDisputeModal.isOpen}
        onHide={vulnDisputeModal.onClose}
        onSubmit={onSubmit}
        asyncStatus={asyncStatus}
      />
    </>
  );
};

export default VulnerabilityIssueDetailsFooter;
